import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const roleResources = {
  listRoles: createResourceBuilder('/identities/role', EResourceMethod.Get),
};
